import { useEffect, useState } from 'react'

let isConfettiOnState = false
let listeners = []

const setConfettiState = (state) => {
    isConfettiOnState = state
    listeners.forEach(listener => listener(isConfettiOnState))
}

const subscribe = (listener) => {
    listeners.push(listener)
    return () => {
        listeners = listeners.filter(l => l !== listener)
    }
}


export const useConfetti = () => {
    const [isConfettiOn, setConfettiOn] = useState(isConfettiOnState)

    useEffect(() => {
        const unsubscribe = subscribe(setConfettiOn)
        return () => unsubscribe()
    }, [])

    return isConfettiOn
}

export const toggleConfetti = (state) => setConfettiState(state)